import styled from '@emotion/styled';
import { Color } from '@liveoptics/react-ui';
import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;
type Icon = (p: IconProps) => React.ReactElement<SVGSVGElement>;

const Svg = styled.svg`
  circle:hover + path {
    filter: saturate(2);
  }
`;

const UnlinkedIcon: Icon = () => (
  <Svg width="48" height="34" viewBox="0 0 48 34">
    <g transform="translate(-756 -695)">
      <g transform="translate(187 -52)">
        <circle cx="17" cy="17" r="17" transform="translate(569 747)" fill="#eee" />
        <path
          d="M5.734,4.118,6.9,3.953l-.355-2.49-1.163.165ZM3.948,6.9l.166-1.163L1.623,5.383,1.457,6.546Zm-.4-4.17-.832.832L4.5,5.343l.831-.832L3.549,2.731ZM13.679,15.3l-1.162.166.354,2.49,1.164-.165L13.679,15.3Zm1.785-2.783L15.3,13.683l2.492.355.166-1.163-2.491-.355Zm.4,4.17.83-.831-1.78-1.78-.83.832,1.779,1.779ZM18,1.421a4.854,4.854,0,0,1,0,6.861L14.85,11.428l-1.144-1.144,3.146-3.146a3.234,3.234,0,0,0-4.573-4.573L9.133,5.71,7.989,4.567l3.146-3.146a4.852,4.852,0,0,1,6.861,0ZM11.423,14.854l-3.111,3.11A4.851,4.851,0,1,1,1.451,11.1l3.113-3.11L5.706,9.137,2.6,12.247A3.234,3.234,0,1,0,7.169,16.82l3.11-3.11,1.144,1.144Z"
          transform="translate(575.97 754)"
          fill="#0076cd"
        />
      </g>
      <rect width="20" height="20" rx="10" transform="translate(784 695)" fill="#fae3a6" />
      <path
        d="M105.9,532.524l-4.98-9.971a1,1,0,0,0-1.788,0L94.114,532.6a.989.989,0,0,0,.041.964,1,1,0,0,0,.853.478h10.035a1,1,0,0,0,1-1A1.011,1.011,0,0,0,105.9,532.524Zm-5.871.513a1,1,0,1,1,1-1A1.1,1.1,0,0,1,100.027,533.037Zm1-3.01H99.024l-.072-5.017H101.1Z"
        transform="translate(694.206 177.214)"
        fill={Color.gold600}
      />
    </g>
  </Svg>
);

export default UnlinkedIcon;
